import React from "react";
import type { FunctionComponent } from "react";
import { observer } from "mobx-react-lite";
import Dropdown from "react-bootstrap/Dropdown";
import camelCase from "lodash/camelCase";
import Tooltip from "@edaz/edazkit/Tooltip";
import type VehicleRegisterVehicle from "entities/vehicleRegisterVehicleResponse";
import type VehicleRegisterViewModel from "viewModels/callCenter/search/vehicleRegister/vehicleRegisterViewModel";

export interface VehicleRegisterActionMenuProps {
  vm: VehicleRegisterViewModel;
  vehicleRegister: VehicleRegisterVehicle;
}

const VehicleRegisterActionMenu: FunctionComponent<VehicleRegisterActionMenuProps> = observer(
  (props: VehicleRegisterActionMenuProps) => {
    const { vm, vehicleRegister } = props;

    return (
      <Dropdown drop="left">
        <Dropdown.Toggle size="sm" variant="success" className="rounded caret-off">
          ⋮
        </Dropdown.Toggle>
        <Dropdown.Menu alignRight={true}>
          {vm.actions.map(action => {
            const allowed = vm[`allowTo${action}`](vehicleRegister);
            let content: React.ReactNode = vm.translate(`actions.${camelCase(action)}.name`);
            if (!allowed) {
              content = (
                <Tooltip id={`vehicleRegister-${vehicleRegister.vehicleId}-${action}`} tooltip={vm.disabledActionTooltip(action)}>
                  <span>{content}</span>
                </Tooltip>
              );
            }

            return (
              <Dropdown.Item
                key={action}
                disabled={!allowed}
                onClick={() => vm[`on${action}Click`](vehicleRegister)}
                style={{ pointerEvents: "auto" }}>
                {content}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
);

export default VehicleRegisterActionMenu;
